/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Nav_LabelInputs */

const da_legal_nav_label = /** @type {(inputs: Legal_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juridiske sider`)
};

/** @type {(inputs: Legal_Nav_LabelInputs) => LocalizedString} */
const en_legal_nav_label = da_legal_nav_label;

/**

* @param {Legal_Nav_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_nav_label = /** @type {((inputs?: Legal_Nav_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Nav_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_nav_label(inputs)
	return /** @type {LocalizedString} */ ("Juridiske sider")
});